import { apiClient } from './authService';

const supplierService = {
  // Get all suppliers
  getAllSuppliers: async () => {
    try {
      const response = await apiClient.get('suppliers/?page_size=1000');
      console.log('Suppliers API response:', response.data);
      // Handle paginated response by checking for results property
      return response.data.results || response.data;
    } catch (error) {
      console.error('Error fetching suppliers:', error);
      throw error.response?.data || { message: 'Error fetching suppliers' };
    }
  },

  // Get supplier by ID
  getSupplierById: async (id) => {
    try {
      const response = await apiClient.get(`suppliers/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching supplier ${id}:`, error);
      throw error.response?.data || { message: 'Error fetching supplier details' };
    }
  },

  // Create new supplier
  createSupplier: async (supplierData) => {
    try {
      const response = await apiClient.post('suppliers/', supplierData);
      return response.data;
    } catch (error) {
      console.error('Error creating supplier:', error);
      throw error.response?.data || { message: 'Error creating supplier' };
    }
  },

  // Update supplier
  updateSupplier: async (id, supplierData) => {
    try {
      const response = await apiClient.put(`suppliers/${id}/`, supplierData);
      return response.data;
    } catch (error) {
      console.error(`Error updating supplier ${id}:`, error);
      throw error.response?.data || { message: 'Error updating supplier' };
    }
  },

  // Delete supplier
  deleteSupplier: async (id) => {
    try {
      const response = await apiClient.delete(`suppliers/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting supplier ${id}:`, error);
      throw error.response?.data || { message: 'Error deleting supplier' };
    }
  }
};

export default supplierService;
